export function exportData(filename, data){
    let anchor = document.createElement("a");
    anchor.setAttribute("download", filename);
    anchor.setAttribute("href", data.data);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}